// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Notification\ApiNotification.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { PCUser, PCUserData, PCUserOptions } from 'data/models/PCUser';

// NotificationData is the class that Notification serializes to/from
export interface NotificationData {
    EventId : number;
    UserId : number;
	
    Event : EventData | null;
    User : PCUserData | null;
	
    Email : boolean;
    EmailDate : /* ISO8601 */ string | null;
    Push : boolean;
    PushDate : /* ISO8601 */ string | null;
    Web : boolean;
    WebDate : /* ISO8601 */ string | null;
}

// NotificationOptions is the class which may be passed to the Notification constructor to define optional initial data values
export interface NotificationOptions {
    EventId : number;
    UserId : number;
	
    Event? : EventOptions | null;
    User? : PCUserOptions | null;
	
    Email? : boolean;
    EmailDate? : /* ISO8601 */ string | null;
    Push? : boolean;
    PushDate? : /* ISO8601 */ string | null;
    Web? : boolean;
    WebDate? : /* ISO8601 */ string | null;
}

export class Notification {
    public EventId : DataSignal<number>;
    public UserId : DataSignal<number>;
	
    public Event : DataSignal<Event | null>;
    public User : DataSignal<PCUser | null>;
	
    public Email : DataSignal<boolean>;
    public EmailDate : DataSignal<TZDate | null>;
    public Push : DataSignal<boolean>;
    public PushDate : DataSignal<TZDate | null>;
    public Web : DataSignal<boolean>;
    public WebDate : DataSignal<TZDate | null>;

    constructor();
    constructor(data : NotificationOptions);
    constructor(data: NotificationOptions | null = null) {
        this.EventId = jsonableObservable(S.value<number>(data && data.EventId !== undefined ? data.EventId : 0));
        this.UserId = jsonableObservable(S.value<number>(data && data.UserId !== undefined ? data.UserId : 0));
	    
        this.Event = S.value<Event | null>(null);
        this.User = S.value<PCUser | null>(null);
	    
        this.Email = jsonableObservable(S.value<boolean>(data && data.Email !== undefined ? data.Email : false));
        this.EmailDate = jsonableObservable(S.value<TZDate | null>(data && data.EmailDate !== undefined ? data.EmailDate === null ? null : new TZDate(data.EmailDate) : null, TZDate.nullableEq));
        this.Push = jsonableObservable(S.value<boolean>(data && data.Push !== undefined ? data.Push : false));
        this.PushDate = jsonableObservable(S.value<TZDate | null>(data && data.PushDate !== undefined ? data.PushDate === null ? null : new TZDate(data.PushDate) : null, TZDate.nullableEq));
        this.Web = jsonableObservable(S.value<boolean>(data && data.Web !== undefined ? data.Web : false));
        this.WebDate = jsonableObservable(S.value<TZDate | null>(data && data.WebDate !== undefined ? data.WebDate === null ? null : new TZDate(data.WebDate) : null, TZDate.nullableEq));
    }

    static key(obj : Notification) {
        return obj.EventId() + '\u2618' + obj.UserId();
    }
    
    static dataKey(obj : NotificationOptions) {
        return obj.EventId + '\u2618' + obj.UserId;
    }

    static update(obj : Notification, data : NotificationOptions) {
        S.freeze(() => {
            if (data.EventId !== undefined) obj.EventId(data.EventId);
            if (data.UserId !== undefined) obj.UserId(data.UserId);
	        
	        
            if (data.Email !== undefined) obj.Email(data.Email);
            if (data.EmailDate !== undefined) obj.EmailDate(data.EmailDate === null ? null : new TZDate(data.EmailDate));
            if (data.Push !== undefined) obj.Push(data.Push);
            if (data.PushDate !== undefined) obj.PushDate(data.PushDate === null ? null : new TZDate(data.PushDate));
            if (data.Web !== undefined) obj.Web(data.Web);
            if (data.WebDate !== undefined) obj.WebDate(data.WebDate === null ? null : new TZDate(data.WebDate));
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/Notification.ts